export const ADD_LICENSE_PATH = "add-license";
export const ADD_STATE_MODAL_PATH = "add-state";
export const SUBMITTING_LICENSE_MODAL_PATH = "submitting-license";
export const LICENSE_IN_REVIEW_MODAL_PATH = "in-review";
export const ADD_QUALIFICATION_MODAL_PATH = "add-qualification";
export const LICENSE_DUPLICATE_MODAL_PATH = "duplicate";
export const LICENSE_ERROR_MODAL_PATH = "error";
